// 引入拦截器
import axios from '@/utils/fetch'
import {HttpResp} from "../constant";

// 声明基础访问地址
axios.defaults.baseURL = HttpResp.BASE_URL

/**
 * 查询任务列表
 * @returns {*}
 */
export function groupByWithDate(params) {
  return axios.get('/system/car/trackRecord/groupByWithDate', {params: params}).then(res => res.data);
}
/**
 * 根据id修改状态
 * @returns {*}
 */
export function getPointByDatetime(params) {
  return axios.get('/system/car/trackRecord/getPointByDatetime', {params: params}).then(res => res.data);
}
/**
 * 根据关键字查地址定位点
 * @returns {*}
 */
export function listAddressPointByKeyword(params) {
  return axios.get('/system/car/gzjj/listAddressPointByKeyword', {params: params}).then(res => res.data);
}
/**
 * 根据定位查地址定位点
 * @returns {*}
 */
export function listAddressPointByLocation(params) {
  return axios.get('/system/car/gzjj/listAddressPointByLocation', {params: params}).then(res => res.data);
}



// WEBPACK FOOTER //
// ./src/api/car.js